import { MemberBasicHash } from '@models/member/member-basic-hash';
import { StaffBasic } from '@models/staff/staff-basic';
import moment from 'moment';
import { TypeStaffTask } from 'src/app/enumerates/type-staff-task';
import { ServiceVideoType } from '@schedule/enumerate/service/service-video-type';
import { ScheduleServiceVideo } from './schedule-service-video';
import { ScheduleServiceGroup } from './schedule-service-group';

export class ScheduleServiceFull {
    id!: string;
    idRoom?: string;
    idService?: string;
    idMember?: string;
    idStaff!: string;
    programDate!: Date;
    validationDate?: Date;
    description!: string;
    typeVisibility?: number;
    typeVideo?: ServiceVideoType;
    duration!: number;
    name!: string;
    isPublic?: boolean;
    isPayment?: boolean;
    amountCredits?: number;
    notifyMember?: boolean;
    notifyStaff?: boolean;
    capacity?: number;
    bookedPlaces?: number;
    video?: ScheduleServiceVideo;
    group?: ScheduleServiceGroup;
    staff?: StaffBasic;
    member?: MemberBasicHash;
    members?: MemberBasicHash[];
    type!: TypeStaffTask;

    startTime?: string;
    endTime?: string;

    build(content: any): this {
        Object.assign(this, content);

        if (content.programDate && content.type === TypeStaffTask.tarea) {
            this.startTime = moment(content.programDate).utc().format('HH:mm');
            this.endTime = moment(content.programDate).add(content.duration, 'm').utc().format('HH:mm');
        }

        return this;
    }
}
